import { render, staticRenderFns } from "./Patient_Doctor_Report.vue?vue&type=template&id=08ab64f4&"
import script from "./Patient_Doctor_Report.vue?vue&type=script&lang=js&"
export * from "./Patient_Doctor_Report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports